import { LightningElement, api, wire } from "lwc";

import { EffectAdapter } from "common/effectAdapter";

export default class extends LightningElement {
  @api html: string = "";

  private node = document.createElement("span");

  @wire(EffectAdapter, { html: "$html" })
  private onHtml() {
    this.node.innerHTML = this.html;
  }

  connectedCallback() {
    this.node.innerHTML = this.html;
    this.template.host.append(this.node);
  }
}
